var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2509_4097)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 50,
    height: 50,
    rx: 12,
    fill: "black",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9296 12C29.253 11.9999 29.5632 12.1284 29.7918 12.3572L34.2432 16.8105C34.7189 17.2864 34.7189 18.0578 34.2432 18.5337L21.6396 31.1428C21.4111 31.3715 21.101 31.5 20.7777 31.5H16.3187C15.6457 31.5 15.1 30.9543 15.1 30.2812V25.8449C15.1 25.5219 15.2282 25.2122 15.4564 24.9837L28.0675 12.3575C28.2961 12.1287 28.6062 12.0001 28.9296 12ZM13.7848 35.4303C13.0752 35.4303 12.5 36.0055 12.5 36.715C12.5 37.4246 13.0752 37.9998 13.7848 37.9998H37.2152C37.9248 37.9998 38.5 37.4246 38.5 36.715C38.5 36.0055 37.9248 35.4303 37.2152 35.4303H13.7848Z",
    fill: "#FDBAFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 11.5,
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2509_4097",
    x: -11.5,
    y: -12,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2509_4097"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2509_4097",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon_edit.3adea6b44db6aea5884640e068081d1a.svg";
export { ForwardRef as ReactComponent };